import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterBoolean',
    standalone: false
})
export class FilterBooleanPipe implements PipeTransform {
  transform(value: boolean[], flag: boolean): boolean[] {
    return value?.filter((item: boolean) => item === flag);
  }
}
